import { warehouseEntity } from "../../domain/entities/warehouse";
import http from "../../../../plugins/http-common"
import i18n from "../../../../i18n";

export const HttpWarehouseRepository = {
  model: warehouseEntity,

  async index() {
    const res = await http.get('warehouses');
    const arr = [];

    res.data.forEach( x => {
        x["actions"] = [{
            name: i18n.t('warehouses.edit'),
            icon: {
                color: 'accent',
                icon: 'edit'
            },
            link: '',
            permission: "warehouse.update"
        },
        {
            name: i18n.t('warehouses.delete'),
            icon: {
                color: 'accent',
                icon: 'delete'
            },
            method: 'askDelete',
            permission: "warehouse.delete"
        }]

        x.actions[0].link = 'warehouses/edit/' + x.id;
        x['address'] = x.municipality  + ' ' + x.neighborhood + ' ' + x.street + ' ' + x.external_number
        x['parameters'] = x;

        arr.push(x);
    })

    return arr;
  },
};